export default "__VITE_ASSET__DgArFzjy__"